import React     from 'react';
import PropTypes from 'prop-types';

const RATINGS = [
    'BAD',
    'GREAT',
];

const IconButton = ({isSelected, onClick, type}) => {
    const iconClass = isSelected ? `${type}-full` : `${type}-line`;

    const onClickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onClick();
    };

    return (
            <span onClick={(event) => onClickHandler(event)}>
      <i className={`icon h-cursor-pointer -size-sm -icon-${iconClass}`} />
    </span>
    );
};

IconButton.propTypes = {
    onClick:    PropTypes.func,
    isSelected: PropTypes.bool,
    type:       PropTypes.oneOf(['like', 'unlike']).isRequired,
};

const FeatureFeedbackPopupRatingButtonsLikes = ({selectedRating, onSelectRating}) => (
        <div className="feature-feedback__popup__rating-buttons--likes">
            <IconButton type={'like'} key={RATINGS[1]} onClick={() => onSelectRating(RATINGS[1])} isSelected={selectedRating === RATINGS[1]} />
            <IconButton type={'unlike'} key={RATINGS[0]} onClick={() => onSelectRating(RATINGS[0])} isSelected={selectedRating === RATINGS[0]} />
        </div>
);

FeatureFeedbackPopupRatingButtonsLikes.propTypes = {
    selectedRating: PropTypes.string,
    onSelectRating: PropTypes.func,
};

export default FeatureFeedbackPopupRatingButtonsLikes;
